import { AddressChangeContext } from 'components/StraightThroughAddressComp/AddressContext/AddressChangeContext'
import ValidationModal from 'components/ValidationModal'
import { useContext, useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import AddDriverForm from './1_Household/Drivers/AddDriverForm/AddDriverForm'
import DriversOnPolicy from './1_Household/Drivers/DriversOnPolicy'
import UpdateDriverForm from './1_Household/Drivers/UpdateDriverForm/UpdateDriverForm'
import AddHhmForm from './1_Household/HouseholdMembers/AddHhmForm/AddHhmForm'
import HouseholdMembersOnPolicy from './1_Household/HouseholdMembers/HouseholdMembersOnPolicy'
import UpdateHhmForm from './1_Household/HouseholdMembers/UpdateHhmForm/UpdateHhmForm'
import ButtonInput from './CustomInputs/ButtonInput/ButtonInput'
import { useDriverHHM } from './HouseholdContext/DriverHHMContext'
import { HouseholdChangeContext } from './HouseholdContext/HouseholdChangeContext'

const StraightThrough_OnPolicyInput = () => {
    const addressChangeContext = useContext(AddressChangeContext)
    const householdChangeContext = useContext(HouseholdChangeContext)
    const driverHHMContext = useDriverHHM();
    const location = useLocation()
    const context = location.pathname.includes("address") ? addressChangeContext : householdChangeContext;
    const changeClass = location.pathname.includes("address") ? addressChangeContext?.addressChangeClass : householdChangeContext?.householdChangeClass;
    const formTypes = ["Add Driver", "Add Household Member", "Update HHM", "Update Driver"]
    const [isLargeScreen, setIsLargeScreen] = useState(false);

    // Update state based on window size
    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth >= 768) {
                setIsLargeScreen(true);
            } else {
                setIsLargeScreen(false);
            }
        };

        window.addEventListener('resize', handleResize);
        handleResize();
        return () => window.removeEventListener('resize', handleResize);
    }, []);
    return (
        <>
            {!(formTypes?.includes(driverHHMContext?.driverHHM?.componentTracker)) &&
                <>
                    {/* Drivers */}
                    <DriversOnPolicy
                        context={context}
                        changeClass={changeClass}
                        method={driverHHMContext.setForm}
                    />
                    <ButtonInput
                        label={"Add New Driver"}
                        type={"Driver"}
                        method={(e) => driverHHMContext.setForm(e.target.value)}
                    />

                    {/* Household Members */}
                    <HouseholdMembersOnPolicy
                        context={context}
                        changeClass={changeClass}
                        method={driverHHMContext.setForm}
                    />
                    <ButtonInput
                        label={"Add New Household Member"}
                        type={"Household Member"}
                        method={(e) => driverHHMContext.setForm(e.target.value)}
                    />
                </>
            }

            {/* Dynamic Form Rendering */}
            {{
                "Add Driver": <AddDriverForm context={context} />,
                "Add Household Member": <AddHhmForm context={context} />,
                "Update Driver": <UpdateDriverForm context={context} changeClass={changeClass} />,
                "Update HHM": <UpdateHhmForm context={context} />,
            }[driverHHMContext?.driverHHM?.componentTracker] || null}

            <ValidationModal
                title={context.validationTitle}
                show={context.showModal}
                handleClose={() => context.setShowModal(false)}
                validationMsg={context.validationMsg}
            />
        </>
    )
}

export default StraightThrough_OnPolicyInput